/** Open one conversation in its own small window (`#/chat/<id>?popout=1`). */
export function popOut(conversationId: string) {
  const w = window.open(`${window.location.pathname}#/chat/${conversationId}?popout=1`, `xc-chat-${conversationId}`, 'popup=yes,width=440,height=720');
  w?.focus();
}
